import { Brand, type BrandProps } from '@/shared/components/Brand'
import { useBootstrap } from '../bootstrap'

export function SessionBrand({ to, ...props }: BrandProps) {
  const { data: session } = useBootstrap()
  const destination = to ?? (session?.user ? session.links?.dashboard || '/dashboard' : '/')
  return <Brand {...props} to={destination} />
}
